import { render } from "./ChangeRoom.vue?vue&type=template&id=c687826e"
import script from "./ChangeRoom.vue?vue&type=script&lang=js"
export * from "./ChangeRoom.vue?vue&type=script&lang=js"

import "./ChangeRoom.vue?vue&type=style&index=0&id=c687826e&lang=scss"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__